module.exports = __webpack_public_path__ + "media/images/flags/GT-6c5a77b192d43712e73a6e430b7bf327.svg";